import React, { useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LoginContext } from '../../../context/LoginContext';
import { SignupContext } from '../../../context/SignupContext';

const DASHBOARD_PATH = '/recently-joined-matches/';

const RegistrationThankYou = () => {
  const navigate = useNavigate();
  const { isLoggedIn, userData, setIsLoggedIn, setUserId, setUserdata } = useContext(LoginContext);
  const { isLoggedIn: signupLoggedIn, userId: signupUserId } = useContext(SignupContext);

  useEffect(() => {
    // Clear handoff flag so later visits to /desired-partner go to dashboard normally.
    try {
      sessionStorage.removeItem('hs_reg_thankyou');
    } catch (_) {}

    if (!isLoggedIn && (signupLoggedIn || userData?.user_id || Number(userData?.status) === 1)) {
      setIsLoggedIn(true);
      const uid = signupUserId || userData?.user_id || userData?.id;
      if (uid) setUserId(uid);
      if (userData && Number(userData.status) !== 1) {
        setUserdata({ ...userData, status: 1 });
      }
      return;
    }

    if (!isLoggedIn && !signupLoggedIn && !userData?.user_id) {
      navigate('/login/', { replace: true });
    }
  }, [
    isLoggedIn,
    signupLoggedIn,
    signupUserId,
    userData,
    navigate,
    setIsLoggedIn,
    setUserId,
    setUserdata,
  ]);

  return (
    <div className="reg-thankyou-page">
      <main className="reg-thankyou-content">
        <h1 className="reg-thankyou-title">
          Thank <span className="reg-thankyou-accent">You!</span>
        </h1>
        <p className="reg-thankyou-subtitle">
          Your registration is successful.
          <br />
          We&apos;re happy to have you with us.
        </p>
        <Link to={DASHBOARD_PATH} className="reg-thankyou-btn" replace>
          Go to Dashboard →
        </Link>
      </main>

      <style>{`
        .reg-thankyou-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fafafa;
          padding: 2rem 1.25rem;
        }
        .reg-thankyou-content {
          text-align: center;
          max-width: 420px;
          width: 100%;
        }
        .reg-thankyou-title {
          margin: 0 0 1.1rem;
          font-size: clamp(2.4rem, 6vw, 3.4rem);
          font-weight: 700;
          line-height: 1.15;
          color: #1a1a1a;
          font-family: Georgia, 'Times New Roman', serif;
        }
        .reg-thankyou-accent {
          color: #E53D5C;
        }
        .reg-thankyou-subtitle {
          margin: 0 0 2rem;
          font-size: 1.05rem;
          line-height: 1.55;
          color: #6b7280;
          font-family: system-ui, -apple-system, 'Segoe UI', sans-serif;
        }
        .reg-thankyou-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 0.35rem;
          background: #E53D5C;
          color: #fff !important;
          text-decoration: none;
          padding: 0.85rem 1.9rem;
          border-radius: 999px;
          font-weight: 600;
          font-size: 1rem;
          font-family: system-ui, -apple-system, 'Segoe UI', sans-serif;
          transition: background 0.2s ease, transform 0.15s ease;
        }
        .reg-thankyou-btn:hover {
          background: #c73658;
          color: #fff !important;
          transform: translateY(-1px);
        }
      `}</style>
    </div>
  );
};

export default RegistrationThankYou;
